import MainLayout from "../Components/layout/layout";
import Home from "./Home";
import AllDonations from "./Donation/AllDonations";
import AddDonation from "./Donation/AddDonation";
import AllExpenses from "./Expenses/AllExpenses";
import CreateExpenses from "./Expenses/CreateExpenses";
import EditDonation from "./Donation/EditDonation";
import EditExpenses from "./Expenses/EditExpenses";
import ActivityLog from "./Donation/ActivityLog";
import Login from "./Login/Login";
import Gallery from "./Gallery/Gallery";
import { Community } from "./Community/Community";
import Events from "./Events/Events";
import DashboardLogin from "./Dashboard/DashboardLogin";
import DashboardLayout from "./Dashboard/DashboardLayout";
import Overview from "./Dashboard/Overview";
import ManageMembers from "./Dashboard/ManageMembers";
import ManageEvents from "./Dashboard/ManageEvents";
import ManagePosts from "./Dashboard/ManagePosts";
import ManageGallery from "./Dashboard/ManageGallery";
import ManageLive from "./Dashboard/ManageLive";
import SiteSettings from "./Dashboard/SiteSettings";

export const MainRoutes = () => [
  {
    element: <MainLayout />,
    children: [
      {
        path: "/",
        element: <Home />,
      },
      {
        path: "*",
        element: <Home />,
      },
      {
        path: "/login",
        element: <Login />,
      },
      {
        path: "/donations/addDonation",
        element: <AddDonation collection={"donation"} />,
      },
      {
        path: "/donations/editDonation",
        element: <EditDonation collection={"donation"} />,
      },
      {
        path: "/donations",
        element: <AllDonations collection={"donation"} />,
      },
      {
        path: "/expenses",
        element: <AllExpenses />,
      },
      {
        path: "/expenses/addExpense",
        element: <CreateExpenses />,
      },
      {
        path: "/expenses/editExpense",
        element: <EditExpenses />,
      },
      {
        path: "/gallery",
        element: <Gallery />,
      },
      {
        path: "/community",
        element: <Community />,
      },
      {
        path: "/events",
        element: <Events />,
      },
      {
        path: "/activity",
        element: <ActivityLog />,
      },
    ],
  },
  {
    path: "/dashboard/login",
    element: <DashboardLogin />,
  },
  {
    path: "/dashboard",
    element: <DashboardLayout />,
    children: [
      { path: "", element: <Overview /> },
      { path: "members", element: <ManageMembers /> },
      { path: "events", element: <ManageEvents /> },
      { path: "posts", element: <ManagePosts /> },
      { path: "gallery", element: <ManageGallery /> },
      { path: "live", element: <ManageLive /> },
      { path: "settings", element: <SiteSettings /> },
    ],
  },
];
